module.exports = __webpack_public_path__ + "img/CS48Q-中_06.8ce88601.jpg";